<template>
  <filter-summary
    icon="option"
    title="オプション"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div v-if="evaluationOptionLabel && evaluationOptionLabel.length > 0">
      評価表示：{{ evaluationOptionLabel }}
    </div>
    <div v-if="segmentLabelY && segmentLabelY.length > 0">
      顧客セグメント(縦軸)：{{ segmentLabelY }}
    </div>
    <div v-if="segmentLabelX && segmentLabelX.length > 0">
      顧客セグメント(横軸)：{{ segmentLabelX }}
    </div>

    <div>評価項目：{{ evaluationsLabel }}</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    evaluationOption: {
      type: String,
      default: '',
    },
    customerSegmentY: {
      type: String,
      default: '',
    },
    customerSegmentX: {
      type: String,
      default: '',
    },
    evaluations: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
    evaluationOptionLabel() {
      return this.$store.state.labels.evaluationOption[this.evaluationOption]
    },
    segmentLabelY() {
      return this.$store.state.labels.customerSegment[this.customerSegmentY]
    },
    segmentLabelX() {
      return this.$store.state.labels.customerSegment[this.customerSegmentX]
    },
    evaluationsLabel() {
      const labels = this.$store.state.labels.evaluations
      let l = []

      for (const e of this.evaluations) {
        l.push(labels[e])
      }

      return l.join('、')
    },
  },
}
</script>
